import { render, staticRenderFns } from "./DataIndukKelasDetail.vue?vue&type=template&id=120920fb"
import script from "./DataIndukKelasDetail.vue?vue&type=script&lang=js"
export * from "./DataIndukKelasDetail.vue?vue&type=script&lang=js"
import style0 from "./DataIndukKelasDetail.vue?vue&type=style&index=0&id=120920fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports